export const sharedProfileIdentity = {
  headline:
    "Forward Deployed Engineer | MSc Advanced CS @ University of Liverpool | 9x Google-Certified | GCP Professional ML Engineer | Trustworthy RAG | AI Observability | Micro-Frontend Architecture | Basketball🏀",
  location: "Greater Liverpool Area, United Kingdom",
  interests: [
    "Machine Learning",
    "Data Science",
    "AI",
    "Trustworthy RAG",
    "Micro-Frontend Architecture",
    "AWS",
    "AI Observability",
    "Basketball🏀",
  ],
  aboutParagraphs: [
    "Most people online know me as dragon. I am 24, and I work as a Forward Deployed Engineer while pursuing an MSc in Advanced Computer Science at the University of Liverpool. I like leading from the front, staying close to the people I work with, and shipping things that solve real problems.",
    "My journey started with a BE in Computer Science with a 9.17 CGPA, then early R&D roles at Infyleads, IVIS International, and Accenture. Today, I focus on trustworthy RAG, AI observability, and micro-frontend architecture while keeping my work practical and product-focused. I also earned the GCP Professional ML Engineer certification and a Tech Expert badge along the way.",
    "Outside work, anime, manga, and Japanese culture keep my creative side alive, and a spiritual mindset keeps me intentional without being religious. I communicate directly, care about impact, and keep learning fast & am focused on ML and data science, and building toward reliable systems teams can trust in production.",
  ],
};
